const localStands = ['stage', 'local'];
class Url {
    _stand;
    constructor(_stand) {
        this._stand = _stand;
    }
    static isStage(stand) {
        return localStands.indexOf(stand) > -1;
    }
    toString() {
        return `https://sfb${Url.isStage(this._stand) ? '-stage' : ''}.samoletgroup.ru/v1/static/sfb.js`;
    }
}
export default Url;
